import { localStorageKey, useGlobalStore } from "./store";
import { setUser } from "@sentry/react";
import posthog from "posthog-js";

/**
 * Clears all application state including localStorage, Zustand store,
 * and analytics user data.
 *
 * This should be called when:
 * - User logs out
 * - User changes (different user logs in)
 * - Organization changes
 * - Auth errors occur that require full cleanup
 */
export const clearApplicationState = (): Promise<void> => {
  return new Promise(resolve => {
    // Clear localStorage first to prevent Zustand from reading stale data
    localStorage.removeItem(localStorageKey);

    useGlobalStore.setState({
      user: null,
      selectedTeam: null
    });

    // Clear localStorage again in case Zustand persisted the reset state
    localStorage.removeItem(localStorageKey);

    posthog.reset();
    setUser(null);

    resolve();
  });
};
